module.exports = "https://coursera_assets.s3.amazonaws.com/images/3c51760da56b41955094211c3a4cd179.png";